import Text from '~/components/Text';

interface Props {
  label: string;
}

const Divider = ({ label }: Props) => {
  return (
    <div className="relative flex h-9 w-full flex-row items-center justify-center uppercase">
      <span className="h-0.5 w-full bg-[#E5E7EB]">&nbsp;</span>
      <span className="absolute bg-white p-2">
        <Text size="xs" type="body" weight="regular" theme={'default'}>
          {label}
        </Text>
      </span>
    </div>
  );
};

export default Divider;
